import { render, staticRenderFns } from "./JobAppealPointSp.vue?vue&type=template&id=1b68c33b&scoped=true"
import script from "./JobAppealPointSp.vue?vue&type=script&lang=js"
export * from "./JobAppealPointSp.vue?vue&type=script&lang=js"
import style0 from "./JobAppealPointSp.vue?vue&type=style&index=0&id=1b68c33b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b68c33b",
  null
  
)

export default component.exports